var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _g2, _path33, _g3, _path34, _g4, _path35, _g5, _path36, _g6, _path37, _g7, _path38, _g8, _path39, _g9, _path40, _g10, _path41, _g11, _path42, _g12, _path43, _g13, _path44, _g14, _path45, _g15, _path46, _g16, _path47, _g17, _path48, _g18, _path49, _g19, _path50, _g20, _path51, _g21, _path52, _g22, _path53, _g23, _path54, _g24, _path55, _g25, _path56, _g26, _path57, _g27, _path58, _g28, _path59, _g29, _path60, _g30, _path61, _g31, _path62, _g32, _path63, _g33, _path64, _g34, _path65, _g35, _path66, _g36, _path67, _g37, _path68, _g38, _path69, _g39, _path70, _g40, _path71, _g41, _path72, _g42, _path73, _g43, _path74, _g44, _path75, _g45, _path76, _g46, _path77, _g47, _path78, _g48, _path79, _g49, _path80, _g50, _path81, _g51, _path82, _g52, _path83, _g53, _path84, _g54, _path85, _g55, _path86, _g56, _path87, _g57, _path88, _g58, _path89, _g59, _path90, _g60, _path91, _g61, _path92, _g62, _path93, _g63, _path94, _g64, _path95, _g65, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _g66, _path149, _g67, _path150, _g68, _path151, _g69, _path152, _g70, _path153, _g71, _path154, _g72, _path155, _g73, _path156, _g74, _path157, _g75, _path158, _g76, _path159, _g77, _path160, _g78, _path161, _g79, _path162, _g80, _path163, _g81, _path164, _g82, _path165, _g83, _path166, _g84, _path167, _g85, _path168, _g86, _path169, _g87, _path170, _g88, _path171, _g89, _path172, _g90, _path173, _g91, _path174, _g92, _path175, _g93, _path176, _g94, _path177, _g95, _path178, _g96, _path179, _g97, _path180, _g98, _path181, _g99, _path182, _g100, _path183, _g101, _path184, _g102, _path185, _g103, _path186, _g104, _path187, _g105, _path188, _g106, _path189, _g107, _path190, _g108, _path191, _g109, _path192, _g110, _path193, _g111, _path194, _g112, _path195, _g113, _path196, _g114, _path197, _g115, _path198, _g116, _path199, _g117, _path200, _g118, _path201, _g119, _path202, _g120, _path203, _g121, _path204, _g122, _path205, _g123, _path206, _g124, _path207, _g125, _path208, _g126, _path209, _g127, _path210, _g128, _path211, _g129, _path212, _g130, _path213, _path214, _g131, _path215, _g132, _path216, _g133, _path217, _g134, _path218, _g135, _path219, _g136, _path220, _g137, _path221, _g138, _path222, _g139, _path223, _g140, _path224, _g141, _path225, _g142, _path226, _g143, _path227, _g144, _path228, _g145, _path229, _g146, _path230, _g147, _path231, _g148, _path232, _g149, _path233, _g150, _path234, _g151, _path235, _g152, _path236, _g153, _path237, _g154, _path238, _g155, _path239, _g156, _path240, _g157, _path241, _g158, _path242, _g159, _path243, _g160, _path244, _g161, _path245, _g162, _path246, _g163, _path247, _g164, _path248, _g165, _path249, _g166, _path250, _g167, _path251, _g168, _path252, _g169, _path253, _g170, _path254, _g171, _path255, _g172, _path256, _g173, _path257, _g174, _path258, _g175, _path259, _g176, _path260, _g177, _path261, _g178, _path262, _g179, _path263, _g180, _path264, _g181, _path265, _g182, _path266, _g183, _path267, _g184, _path268, _g185, _path269, _g186, _path270, _g187, _path271, _g188, _path272, _g189, _path273, _g190, _path274, _g191, _path275, _g192, _path276, _g193, _path277, _g194, _path278, _g195, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogThumbnail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 197,
    viewBox: "0 0 438 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_17454)",
    filter: "url(#filter0_d_1046_17454)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 434,
    height: 189,
    transform: "translate(4 4)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.78 207.295C372.406 205.155 340.83 187.151 307.929 168.388C267.299 145.235 225.297 121.269 167.359 123.849C130.351 125.501 106.413 139.137 85.2778 151.188C66.1589 162.089 48.1072 171.609 24.4454 171.14C-13.8204 170.417 -26.1215 153.39 -26.2924 152.393L-25.6946 141.95C-25.6542 142.13 -18.3663 160.869 24.8541 163.116C46.1479 164.233 62.4384 154.942 81.2947 144.203C103.215 131.717 128.043 117.574 167.007 115.832C227.281 113.158 270.315 137.689 311.927 161.405C355.475 186.243 397.059 209.552 452.419 194.476L451.928 203.052C435.945 207.401 423.543 208.082 409.78 207.295Z",
    fill: "url(#paint0_radial_1046_17454)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.631 172.566C159.447 168.289 140.739 146.617 122.442 125.418C108.567 109.348 94.1461 92.8611 76.0287 83.0037C20.7855 52.9343 -15.1298 86.3208 -15.4584 86.6258L-13.6355 75.0385C-13.2493 74.6916 -6.83063 68.5922 9.66506 64.4349C24.6767 60.6301 49.031 59.5438 79.8122 75.9801C99.2977 86.3841 114.165 103.604 128.513 120.232C157.644 153.965 182.802 183.124 239.242 152.559C281.993 129.395 322.359 107.283 359.354 102.707C395.542 98.2336 430.496 111.173 458.993 150.234L457.327 160.826C396.862 77.5214 328.332 113.421 243.086 159.585C220.48 171.775 202.169 174.985 186.631 172.566Z",
    fill: "url(#paint1_linear_1046_17454)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.241 141.826C411.855 139.103 413.065 136.228 413.872 133.252L420.328 132.042L420.378 124.931L420.429 117.82L414.024 116.458C413.267 113.482 412.107 110.557 410.544 107.834L414.225 102.437L409.232 97.3433L404.24 92.2494L398.742 95.8303C396.019 94.2164 393.144 93.006 390.168 92.199L388.958 85.7434L381.847 85.693L374.736 85.6426L373.374 92.0477C370.398 92.8042 367.473 93.9642 364.75 95.5277L359.353 91.846L354.259 96.8389L349.165 101.832L352.746 107.329C351.132 110.053 349.922 112.927 349.115 115.903L342.659 117.113L342.609 124.225L342.559 131.336L348.964 132.698C349.72 135.673 350.88 138.598 352.444 141.322L348.762 146.718L353.755 151.812L358.748 156.906L364.245 153.325C366.969 154.939 369.843 156.149 372.819 156.956L374.029 163.412L381.141 163.462L388.252 163.513L389.614 157.108C392.589 156.351 395.514 155.191 398.238 153.628L403.634 157.309L408.728 152.316L413.822 147.323L410.241 141.826ZM369.087 136.783C362.329 129.924 362.43 118.879 369.339 112.12C376.198 105.362 387.243 105.463 394.001 112.373C400.76 119.232 400.659 130.277 393.749 137.035C386.89 143.743 375.845 143.642 369.087 136.783Z",
    fill: "url(#paint2_linear_1046_17454)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6538 84.3816C100.662 82.2634 101.318 79.9938 101.722 77.7243L106.412 76.3121L105.908 71.0166L105.403 65.721L100.562 65.2166C99.8051 63.048 98.6956 60.9802 97.3338 59.0637L99.6538 54.7768L95.5687 51.3977L91.4835 48.0186L87.7009 51.0951C85.5827 50.0864 83.3132 49.4308 81.0436 49.0273L79.6315 44.3369L74.3359 44.8413L69.0403 45.3456L68.536 50.1873C66.3673 50.9438 64.2995 52.0533 62.383 53.4151L58.0961 51.0951L54.717 55.1802L51.3379 59.2654L54.4144 63.048C53.4057 65.1662 52.7501 67.4357 52.3466 69.7053L47.6562 71.1174L48.1606 76.413L48.6649 81.7086L53.5066 82.2129C54.2631 84.3816 55.3727 86.4494 56.7344 88.3659L54.4144 92.6528L58.4996 96.0319L62.5847 99.411L66.3673 96.3345C68.4855 97.3432 70.7551 97.9988 73.0246 98.4023L74.4368 103.093L79.7323 102.588L85.0279 102.084L85.5323 97.2423C87.7009 96.4858 89.7687 95.3762 91.6852 94.0145L95.9721 96.3345L99.3512 92.2493L102.73 88.1642L99.6538 84.3816ZM68.6368 83.7764C63.0891 79.1869 62.3326 70.9661 66.9221 65.4184C71.5116 59.8706 79.7323 59.1141 85.2801 63.7036C90.8278 68.2931 91.5844 76.5139 86.9949 82.0616C82.4053 87.6094 74.1846 88.3659 68.6368 83.7764Z",
    fill: "url(#paint3_linear_1046_17454)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380.085 191.402H379.631V159.679C379.631 152.618 373.881 146.869 366.821 146.869H334.19C326.877 146.869 320.926 140.918 320.926 133.605V74.395C320.926 67.3343 315.176 61.5848 308.115 61.5848H225V61.1309H308.166C315.479 61.1309 321.43 67.0821 321.43 74.395V133.655C321.43 140.716 327.179 146.465 334.24 146.465H366.871C374.184 146.465 380.135 152.417 380.135 159.73V191.402H380.085Z",
    fill: "#64A4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.906 41.0566C195.906 41.0566 200.95 61.079 188.846 66.5763C176.742 72.0736 179.062 62.0372 179.062 62.0372C179.062 62.0372 174.119 60.6755 187.585 53.0095C193.94 49.3783 195.906 41.0566 195.906 41.0566Z",
    fill: "#BBD070"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.516 42.8252C227.516 42.8252 229.988 60.2754 207.141 67.8405C184.244 75.4056 181.016 84.9881 181.016 84.9881C181.016 84.9881 180.31 46.2547 227.516 42.8252Z",
    fill: "#97A43C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.919 77.8744C174.161 75.3023 190.249 61.3825 202.656 61.7859C215.063 62.139 223.435 66.7285 231.756 64.812C231.706 64.7616 214.306 90.5838 180.919 77.8744Z",
    fill: "#48753A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M203.722 89.4754C204.125 84.2303 204.377 79.2878 204.529 74.6983C203.268 74.0426 201.704 73.2357 200.494 72.6809C196.711 70.8653 191.416 68.4444 188.037 66.881C186.07 65.9732 184.103 65.3175 184.103 65.3175C184.103 65.3175 170.587 64.0062 169.477 64.1071C169.124 64.1071 167.46 64.7123 165.241 65.5697C160.449 67.3853 151.22 71.1174 149.707 72.1766C147.538 73.74 139.822 111.616 139.62 114.188C139.418 116.71 150.11 120.089 160.046 122.712C160.046 126.545 159.945 131.941 159.895 136.833C159.895 137.69 159.844 138.497 159.844 139.304H203.217C203.167 138.447 203.117 137.64 203.066 136.833C203.066 136.732 203.066 136.631 203.066 136.53C202.915 133.202 202.259 127.251 202.41 121.451C202.41 121.451 202.31 115.348 202.915 112.726C203.016 100.974 203.722 89.4754 203.722 89.4754ZM148.648 111.717C148.698 106.774 155.305 97.5953 155.305 97.5953C155.305 97.5953 155.608 97.444 155.608 97.4945L155.961 97.444L156.969 96.4858C157.222 97.3432 159.39 109.75 159.895 116.962C153.742 115.752 148.648 114.087 148.648 111.717Z",
    fill: "#DBD8E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.48 136.733C204.178 134.665 203.925 132.648 203.673 130.63C203.673 130.63 203.673 130.63 203.673 130.58C203.572 129.924 203.522 129.268 203.421 128.613C203.421 128.562 203.421 128.562 203.421 128.512C203.118 125.738 202.816 123.065 202.665 120.644C202.513 118.778 202.665 116.963 202.917 115.197C203.673 102.74 204.026 89.6777 204.026 89.6777C204.43 84.3317 204.631 79.2883 204.783 74.5979C204.783 74.5979 187.786 66.5789 186.273 66.125C186.273 66.125 189.501 73.6901 191.922 90.5855C192.83 97.0915 194.595 108.036 195.805 119.182C196.461 125.183 197.772 131.336 198.731 136.783C198.882 137.641 199.033 138.448 199.134 139.254H204.833C204.732 138.347 204.631 137.54 204.48 136.733Z",
    fill: "#323657"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.239 116.758C176.894 110.454 177.499 104.2 177.197 100.771C174.877 73.1328 168.22 65.8199 167.261 64.7607C166.505 65.0633 163.68 66.1225 162.874 66.4251C158.334 68.1903 149.105 71.4685 147.844 72.3763C145.676 73.9398 137.152 113.631 136.9 116.204C136.749 117.918 147.844 121.55 159.192 124.828C159.091 127.955 159.394 132.342 158.334 136.882C158.133 137.688 157.881 138.193 157.83 139.302L173.616 139.252C173.717 138.445 173.818 137.638 173.919 136.781C174.221 134.309 174.524 131.788 174.826 129.115C179.567 130.325 182.795 131.132 182.795 131.132C182.795 131.132 187.233 123.617 188.544 120.541C188.797 119.986 183.098 118.574 176.239 116.758ZM155.813 107.226C155.661 101.578 155.712 97.6438 155.712 97.6438C156.267 99.5603 157.023 105.108 157.729 110.605C155.409 109.445 155.813 108.386 155.813 107.226Z",
    fill: "#323657"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.773 64.4597C168.773 64.4597 170.488 61.2319 170.034 52.0025C169.883 49.4303 183.45 58.0546 183.45 58.0546C183.45 58.0546 183.399 58.9119 183.349 60.1223C183.349 60.6267 183.349 61.1815 183.349 61.7362C183.349 61.8875 183.349 62.0388 183.349 62.1901C183.349 62.4423 183.349 62.6945 183.349 62.9467C183.349 63.2493 183.349 63.5519 183.399 63.8545C183.399 64.2075 183.45 64.5101 183.45 64.8127C183.5 65.3675 183.853 66.3762 183.954 66.6284C184.61 67.9901 173.867 68.0909 168.773 64.4597Z",
    fill: "#EEA987"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.173 70.3105L182.695 73.6896C182.695 73.6896 181.232 75.6566 178.609 74.194L180.173 70.3105Z",
    fill: "#E8734D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.986 73.8401C181.986 73.8401 191.165 96.1824 189.198 124.627L186.323 129.872L183.045 125.384C183.045 125.384 182.541 87.6591 179.918 73.7393L181.986 73.8401Z",
    fill: "#E8734D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.844 67.1835L180.171 70.3104C180.171 70.3104 175.884 69.5034 174.623 67.2339C173.362 65.0148 182.844 67.1835 182.844 67.1835Z",
    fill: "#EEA987"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.45 64.459C183.45 64.459 183.147 66.8294 180.172 70.3093L183.4 74.6971L185.165 65.619L183.45 64.459Z",
    fill: "#C4C1CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.631 61.584C169.631 61.584 175.834 68.5943 180.172 70.3091L178.154 75.3021L168.219 64.4083L169.631 61.584Z",
    fill: "#C4C1CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M233.477 125.131C233.477 125.131 225.257 117.112 219.81 115.801C217.288 115.196 214.01 111.716 210.883 107.681C209.874 106.37 208.866 104.957 207.857 103.545C204.024 97.9976 200.998 92.702 200.998 92.702C200.998 92.702 189.65 79.3874 198.779 73.4866C198.779 73.4866 202.662 73.3857 204.831 74.5457C207.05 75.7561 211.74 85.5403 212.497 87.2551C213.304 88.9699 221.928 105.109 222.483 105.462C223.038 105.815 224.046 107.126 227.476 108.992C231.712 111.262 238.319 117.919 238.319 117.919L233.477 125.131Z",
    fill: "#323657"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M193.888 134.412C193.888 134.412 192.728 134.362 192.224 134.109C192.224 134.109 191.367 133.555 190.711 133.202C190.509 133.101 190.308 133 190.207 132.949C189.702 132.748 188.542 132.445 187.433 131.638C186.374 130.831 182.793 127.503 182.793 127.503L185.063 123.972L186.122 120.492C186.122 120.492 194.342 121.299 195.452 121.955C195.553 122.005 195.654 122.106 195.755 122.157C196.612 122.812 197.015 123.67 197.419 124.023C197.57 124.174 199.033 125.687 198.932 126.343C198.831 127.2 198.377 127.755 197.873 128.007C197.873 128.007 197.57 129.671 196.713 130.428C196.713 130.428 196.511 131.991 195.149 132.596C195.2 132.647 194.796 134.21 193.888 134.412Z",
    fill: "#EFAA88"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.775 28.1462C180.775 28.1462 195.653 24.5654 192.527 43.4277C189.4 62.2901 185.819 63.8031 176.741 60.071C167.663 56.2884 168.318 44.2347 167.763 38.3339C167.209 32.4331 175.984 28.4488 180.775 28.1462Z",
    fill: "#EEA886"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.962 41.2091C172.761 39.5447 169.432 38.99 169.23 41.4612C168.978 43.9325 170.844 48.2698 172.054 47.8664C173.265 47.4124 173.265 43.529 172.962 41.2091Z",
    fill: "#EEA886"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.623 47.9678C168.623 47.9678 168.926 42.0166 171.094 41.8149C173.263 41.6131 173.616 43.9835 173.616 43.9835L175.785 44.387C175.785 44.387 175.028 39.1923 177.146 38.2845C179.315 37.3262 191.167 40.9575 192.882 39.394C194.597 37.8306 193.638 27.3403 190.461 25.9281C187.284 24.516 178.609 21.4395 172.305 25.8273C172.305 25.8273 167.362 25.3229 166.656 29.3577C166.051 33.2915 167.261 45.0427 168.623 47.9678Z",
    fill: "#16202E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M188.995 120.492L182.842 131.083C182.842 131.083 166.552 126.897 162.77 125.838L171.444 115.499C171.444 115.448 184.254 118.373 188.995 120.492Z",
    fill: "#323657"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.4 63.8554C175.432 63.0485 172.305 56.8955 172.305 56.8955C177.348 61.8885 183.35 61.7372 183.35 61.7372C183.35 61.8885 183.35 62.0398 183.35 62.1911C183.35 62.4433 183.35 62.6954 183.35 62.9476C183.4 63.2502 183.4 63.5528 183.4 63.8554Z",
    fill: "#A77860"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M311.903 157.562C311.449 157.007 310.794 156.604 309.987 156.604C308.928 156.604 307.97 157.259 307.667 158.268C307.566 158.52 307.566 158.772 307.516 159.024C307.516 159.327 307.566 159.63 307.667 159.882C307.818 160.336 308.121 160.689 308.474 160.991C308.827 161.243 309.281 161.445 309.735 161.496C309.785 161.496 309.886 161.496 309.936 161.496C309.987 161.496 310.037 161.496 310.037 161.496H310.088C310.34 161.496 310.542 161.445 310.794 161.344C311.702 160.991 312.357 160.134 312.408 159.075C312.408 158.47 312.256 157.965 311.903 157.562ZM310.592 160.739C310.441 160.79 310.239 160.84 310.088 160.84C310.037 160.84 309.987 160.84 309.987 160.84C309.836 160.84 309.634 160.79 309.483 160.739C309.281 160.689 309.079 160.588 308.877 160.437C308.827 160.386 308.776 160.336 308.676 160.285C308.323 159.932 308.121 159.478 308.171 158.974C308.171 158.823 308.171 158.722 308.222 158.57C308.222 158.52 308.272 158.47 308.272 158.369C308.524 157.663 309.23 157.108 310.037 157.108C310.643 157.108 311.147 157.41 311.449 157.814C311.702 158.117 311.853 158.52 311.803 158.923C311.803 159.781 311.298 160.487 310.592 160.739Z",
    fill: "#4DA8F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M200.543 111.818C209.823 121.35 222.028 133.353 222.028 133.353L226.819 124.275C226.819 124.275 215.976 111.515 208.612 103.042C206.343 104.152 202.207 106.774 200.543 111.818Z",
    fill: "#EEA886"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M213.048 124.628C213.048 124.628 215.519 125.838 216.175 126.393C216.831 126.948 219.453 128.915 220.109 129.369C220.764 129.823 219.151 131.134 214.41 129.117C209.719 127.049 213.048 124.628 213.048 124.628Z",
    fill: "#EEA886"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M195.048 97.3438L190.711 137.741H247.903L252.241 97.3438H195.048Z",
    fill: "#FFC955"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.177 135.875H193.531L197.919 95.0234H255.565L251.177 135.875ZM194.036 135.421H250.774L255.061 95.4773H198.322L194.036 135.421Z",
    fill: "#FFC955"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M204.374 137.713H213.906V134.082H204.374V137.713Z",
    fill: "#FFC955"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.851 137.641H112.48V140.112H114.851V137.641Z",
    fill: "#96CBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.273 137.641H114.902V140.112H117.273V137.641Z",
    fill: "#95CAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.644 137.641H117.273V140.112H119.644V137.641Z",
    fill: "#94C9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.011 137.641H119.641V140.112H122.011V137.641Z",
    fill: "#93C9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.433 137.641H122.062V140.112H124.433V137.641Z",
    fill: "#92C8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.804 137.641H124.434V140.112H126.804V137.641Z",
    fill: "#91C7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.226 137.641H126.855V140.112H129.226V137.641Z",
    fill: "#90C6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.593 137.641H129.223V140.112H131.593V137.641Z",
    fill: "#8FC6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.964 137.641H131.594V140.112H133.964V137.641Z",
    fill: "#8EC5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.386 137.641H134.016V140.112H136.386V137.641Z",
    fill: "#8DC4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.757 137.641H136.387V140.112H138.757V137.641Z",
    fill: "#8CC3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.175 137.641H138.805V140.112H141.175V137.641Z",
    fill: "#8BC2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.546 137.641H141.176V140.112H143.546V137.641Z",
    fill: "#8AC2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.921 137.641H143.551V140.112H145.921V137.641Z",
    fill: "#89C1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.339 137.641H145.969V140.112H148.339V137.641Z",
    fill: "#88C0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.71 137.641H148.34V140.112H150.71V137.641Z",
    fill: "#87BFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.128 137.641H150.758V140.112H153.128V137.641Z",
    fill: "#86BFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.503 137.641H153.133V140.112H155.503V137.641Z",
    fill: "#85BEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.874 137.641H155.504V140.112H157.874V137.641Z",
    fill: "#84BDFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.292 137.641H157.922V140.112H160.292V137.641Z",
    fill: "#83BCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.663 137.641H160.293V140.112H162.663V137.641Z",
    fill: "#82BBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.085 137.641H162.715V140.112H165.085V137.641Z",
    fill: "#81BBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.456 137.641H165.086V140.112H167.456V137.641Z",
    fill: "#80BAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.827 137.641H167.457V140.112H169.827V137.641Z",
    fill: "#7FB9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.245 137.641H169.875V140.112H172.245V137.641Z",
    fill: "#7EB8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.617 137.641H172.246V140.112H174.617V137.641Z",
    fill: "#7DB7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.038 137.641H174.668V140.112H177.038V137.641Z",
    fill: "#7CB7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.409 137.641H177.039V140.112H179.409V137.641Z",
    fill: "#7BB6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.777 137.641H179.406V140.112H181.777V137.641Z",
    fill: "#7AB5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.199 137.641H181.828V140.112H184.199V137.641Z",
    fill: "#79B4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.57 137.641H184.199V140.112H186.57V137.641Z",
    fill: "#78B4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.992 137.641H186.621V140.112H188.992V137.641Z",
    fill: "#77B3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.359 137.641H188.988V140.112H191.359V137.641Z",
    fill: "#76B2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.73 137.641H191.359V140.112H193.73V137.641Z",
    fill: "#74B1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.152 137.641H193.781V140.112H196.152V137.641Z",
    fill: "#73B0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.523 137.641H196.152V140.112H198.523V137.641Z",
    fill: "#72B0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.941 137.641H198.57V140.112H200.941V137.641Z",
    fill: "#71AFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.312 137.641H200.941V140.112H203.312V137.641Z",
    fill: "#70AEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.683 137.641H203.312V140.112H205.683V137.641Z",
    fill: "#6FADFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.105 137.641H205.734V140.112H208.105V137.641Z",
    fill: "#6EADFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.476 137.641H208.105V140.112H210.476V137.641Z",
    fill: "#6DACFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.894 137.641H210.523V140.112H212.894V137.641Z",
    fill: "#6CABFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.265 137.641H212.895V140.112H215.265V137.641Z",
    fill: "#6BAAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.687 137.641H215.316V140.112H217.687V137.641Z",
    fill: "#6AA9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.058 137.641H217.688V140.112H220.058V137.641Z",
    fill: "#69A9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.425 137.641H220.055V140.112H222.425V137.641Z",
    fill: "#68A8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.851 137.641H222.48V140.112H224.851V137.641Z",
    fill: "#67A7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.218 137.641H224.848V140.112H227.218V137.641Z",
    fill: "#66A6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.64 137.641H227.27V140.112H229.64V137.641Z",
    fill: "#65A6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.007 137.641H229.637V140.112H232.007V137.641Z",
    fill: "#64A5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.378 137.641H232.008V140.112H234.378V137.641Z",
    fill: "#63A4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.804 137.641H234.434V140.112H236.804V137.641Z",
    fill: "#62A3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.171 137.641H236.801V140.112H239.171V137.641Z",
    fill: "#61A2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.593 137.641H239.223V140.112H241.593V137.641Z",
    fill: "#60A2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.96 137.641H241.59V140.112H243.96V137.641Z",
    fill: "#5FA1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.331 137.641H243.961V140.112H246.331V137.641Z",
    fill: "#5EA0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.757 137.641H246.387V140.112H248.757V137.641Z",
    fill: "#5D9FFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.124 137.641H248.754V140.112H251.124V137.641Z",
    fill: "#5C9EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.546 137.641H251.176V140.112H253.546V137.641Z",
    fill: "#5B9EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.913 137.641H253.543V140.112H255.913V137.641Z",
    fill: "#5A9DFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.284 137.641H255.914V140.112H258.284V137.641Z",
    fill: "#599CFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.706 137.641H258.336V140.112H260.706V137.641Z",
    fill: "#589BFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.074 137.641H260.703V140.112H263.074V137.641Z",
    fill: "#579BFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.499 137.641H263.129V140.112H265.499V137.641Z",
    fill: "#569AFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 137,
    width: 156,
    height: 4
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M267.868 137.641H112.48V140.112H267.868V137.641Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.867 137.641H265.496V140.112H267.867V137.641Z",
    fill: "#5599FF"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M362.886 190.142H228.227V192.613H362.886V190.142Z",
    fill: "#FFC955"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M221.105 116.86C220.651 119.13 221.71 121.198 223.425 121.601C225.19 121.954 226.956 120.441 227.409 118.171C227.863 115.902 226.804 113.784 225.09 113.431C223.375 113.078 221.559 114.641 221.105 116.86Z",
    fill: "#CFA345"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M395.971 100.875C395.971 100.875 397.283 103.094 397.837 103.497C398.594 104.002 398.14 104.506 397.737 104.506C397.384 104.506 395.568 104.657 395.164 104.203C394.761 103.75 394.559 102.388 394.206 102.035C393.853 101.682 393.45 100.27 394.408 99.9165C395.215 99.5131 395.971 100.875 395.971 100.875Z",
    fill: "#6069A8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M344.985 99.9157C344.985 99.9157 346.498 102.538 346.75 102.942C347.002 103.345 346.246 103.345 345.792 103.143C345.338 102.942 344.178 101.076 343.976 100.723C343.774 100.319 343.926 99.8652 343.926 99.8652L344.985 99.9157Z",
    fill: "#202338"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M393.895 101.277L394.248 104.001H394.399L394.348 102.084L393.895 101.277Z",
    fill: "#6069A8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M382.909 100.873C382.909 100.873 384.22 103.092 384.775 103.496C385.531 104 385.078 104.504 384.674 104.504C384.321 104.504 382.505 104.656 382.102 104.202C381.698 103.748 381.497 102.386 381.144 102.033C380.791 101.68 380.387 100.217 381.345 99.9148C382.152 99.5618 382.909 100.873 382.909 100.873Z",
    fill: "#6069A8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M331.973 99.9153C331.973 99.9153 333.385 102.538 333.687 102.891C333.94 103.294 333.183 103.294 332.729 103.093C332.275 102.891 331.115 101.025 330.913 100.672C330.712 100.268 330.863 99.8145 330.863 99.8145L331.973 99.9153Z",
    fill: "#202338"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M380.785 101.277L381.138 104.001H381.34L381.289 102.084L380.785 101.277Z",
    fill: "#6069A8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M377.051 80.5451L389.004 85.9919C389.004 85.9919 390.315 86.4459 390.466 87.9084C390.92 92.5484 394.4 99.8613 394.4 99.8613C395.51 100.416 395.409 99.9118 395.409 99.9118C394.703 97.6927 393.845 88.4128 393.543 84.7311C393.492 83.9241 393.442 83.4198 393.442 83.2181C393.442 83.1172 393.291 82.9659 393.089 82.7642C391.475 81.4529 384.717 78.679 384.717 78.679C379.673 78.5277 377.051 80.5451 377.051 80.5451Z",
    fill: "#202338"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M374.789 82.8676C375.142 86.0954 379.781 85.7424 379.781 85.7424H385.38C385.38 85.7424 383.917 89.0206 383.362 91.744C382.757 94.6692 381.345 99.8135 381.345 99.8135C381.345 99.8135 381.446 99.9648 382.454 99.9144C382.454 99.9144 386.842 91.1893 388.507 88.9702C388.86 88.5162 389.919 85.9441 390.07 84.3807C390.12 83.8763 390.07 83.4728 389.919 83.3215C389.717 83.1702 389.263 82.8676 388.708 82.4642C386.943 81.3546 383.917 79.6398 382.253 79.2868C379.983 78.7825 376.402 77.8242 376.402 77.8242C376.402 77.8242 374.435 79.6398 374.789 82.8676Z",
    fill: "#202338"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M378.618 58.0037C378.618 58.0037 377.761 56.4403 378.215 54.7255C378.618 53.0612 380.182 51.3464 382.501 52.1029C384.821 52.8595 386.637 54.6751 385.275 56.7429C383.914 58.8107 386.536 59.7185 385.83 60.7272C385.175 61.6854 385.427 62.7445 385.679 62.9463C385.981 63.1984 386.889 64.0054 386.788 64.9636C386.688 65.9219 382.35 62.1393 382.35 62.1393C382.35 62.1393 379.929 57.3985 378.618 58.0037Z",
    fill: "#464240"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M385.581 78.2784C385.581 78.2784 385.228 79.9427 376.301 77.8245C376.351 77.8245 379.327 76.8662 385.581 78.2784Z",
    fill: "#EB4747"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M376.246 78.329C376.094 78.5812 375.993 78.8334 375.842 79.136C379.12 79.2368 382.348 79.3377 385.626 79.4386C385.122 77.7238 385.273 75.3534 385.374 73.5882C385.475 71.4195 386.686 69.9065 386.534 67.7379C387.19 67.8387 387.291 67.8387 387.946 67.9396C386.938 65.1153 386.635 63.7536 383.559 62.644C382.55 62.291 381.894 62.2405 380.835 62.291C377.305 62.5936 376.195 62.644 374.48 65.8214C377.204 66.2753 376.75 67.2335 377.607 69.957C378.011 71.2682 378.414 72.7813 378.213 74.143C377.91 75.5551 376.246 77.0682 376.246 78.329Z",
    fill: "#5F8CC9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M381.897 63.3008C380.434 63.0486 380.737 62.2416 380.737 62.2416C380.737 62.2416 380.787 61.7877 380.838 61.233C380.838 61.0816 380.838 60.9303 380.838 60.779C380.838 60.5269 380.838 60.2747 380.787 60.073C380.686 59.1147 383.41 59.6695 383.41 59.6695C383.41 59.6695 383.259 61.6364 383.612 62.2416C384.066 62.7964 383.359 63.5529 381.897 63.3008Z",
    fill: "#EEA886"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M379.121 62.1904C379.121 62.1904 382.046 65.5695 383.156 66.3765C383.156 66.3765 384.417 65.2669 383.61 62.2913C383.61 62.2913 382.198 61.5852 379.121 62.1904Z",
    fill: "#EEA886"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M379.227 54.0708C379.227 54.0708 377.714 56.996 379.227 59.7699C380.74 62.5437 383.716 58.5594 383.918 58.1055C384.119 57.6516 385.128 54.9786 383.111 54.1717C381.043 53.3647 379.631 53.2639 379.227 54.0708Z",
    fill: "#EEA886"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M379.724 55.1298C379.724 55.1298 378.665 56.4916 378.564 57.5002C378.564 57.5002 378.161 55.5838 379.321 53.7177C380.48 51.8516 383.507 53.6168 383.91 54.3733C384.313 55.1298 385.473 55.7855 383.507 58.9124C383.507 58.9628 379.926 56.4916 379.724 55.1298Z",
    fill: "#464240"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M382.155 60.0723C382.155 60.0723 381.903 60.627 380.844 61.1818C380.844 61.0305 380.844 60.8792 380.844 60.7279C380.894 60.7279 381.55 60.627 382.155 60.0723Z",
    fill: "#A77860"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M366.764 75.657C366.764 75.657 366.058 75.9596 365.705 75.8083C365.352 75.657 364.848 75.657 364.646 75.657C364.444 75.657 363.738 75.4048 363.738 75.657C363.738 75.9092 364.898 76.1109 365.1 76.2118C365.352 76.3126 364.394 76.817 364.343 77.0187C364.243 77.2205 365.302 78.7335 365.857 78.2796C366.462 77.8761 366.764 77.0187 366.865 76.9683C366.966 76.9179 367.319 76.6657 367.319 76.6657L366.764 75.657Z",
    fill: "#EEA886"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M364.446 76.918C364.446 76.918 362.732 78.3301 362.732 78.5319C362.681 78.7336 362.782 78.8345 362.984 78.6832C363.135 78.5823 364.648 77.3719 364.648 77.3719C364.648 77.3719 362.933 79.3892 362.883 79.5405C362.832 79.6414 363.034 79.7927 363.085 79.7423C363.135 79.6918 365.001 77.7753 365.001 77.7753C365.001 77.7753 363.438 79.6414 363.387 79.7927C363.387 79.8936 363.589 80.0449 363.69 79.8936C363.841 79.7423 365.405 78.1284 365.405 78.1284C365.405 78.1284 364.345 79.591 364.396 79.6918C364.446 79.7927 364.547 79.944 364.85 79.5405C365.102 79.1371 365.808 78.3301 365.808 78.3301L364.446 76.918Z",
    fill: "#EEA886"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M384.773 85.7427H379.78C379.78 85.7427 375.19 86.0958 374.787 82.868C374.434 79.6402 376.3 77.875 376.3 77.875C376.3 77.875 378.72 78.5306 380.839 79.035C381.898 78.8332 383.209 78.6819 384.672 78.6819C384.672 78.6819 393.699 81.6576 393.397 83.221C393.447 83.221 389.665 81.2037 384.773 85.7427Z",
    fill: "#FFC955"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M381.547 80.1445L391.079 79.9932L386.237 82.414L381.547 80.1445Z",
    fill: "#5E5853"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M384.47 78.9336C384.47 78.9336 382.302 79.7405 379.679 79.0344L379.578 78.0762L384.975 78.3788L384.47 78.9336Z",
    fill: "#5F8CC9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M386.237 82.4141L381.547 80.5984V80.1445L386.641 81.9602L386.237 82.4141Z",
    fill: "#91887F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M384.471 79.3885C384.421 79.7416 384.824 79.9937 385.127 79.8424L385.681 79.5903C385.833 79.5398 385.934 79.3381 385.934 79.1868C385.681 77.7242 385.228 72.126 385.934 71.1678C386.186 70.8147 386.388 70.5121 386.438 70.2095C386.892 71.4199 387.497 73.0338 387.749 73.8912L392.238 79.8929L393.751 80.2963C391.885 75.7573 390.372 73.3364 390.372 73.3364C390.069 72.5295 389.212 70.1591 388.506 68.0408C388.052 66.6791 387.598 65.4687 387.346 64.7626C387.245 64.4096 386.993 64.1574 386.69 63.9557C385.984 63.5522 384.824 62.8966 383.765 62.3922C383.715 62.3922 383.714 62.3418 383.664 62.3418C385.631 65.3174 384.874 73.8912 384.471 79.3885Z",
    fill: "#EDDAD3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M377.003 62.5421C376.348 62.643 374.784 64.2065 373.927 65.7699C372.969 67.5351 371.96 69.5525 371.254 70.2586C369.892 71.469 366.11 75.8063 365.908 75.7055C365.857 75.655 366.967 77.0167 367.068 77.0672C367.118 77.1176 373.271 71.7716 373.877 70.9646C374.431 70.2081 375.944 66.9803 376.398 67.0308C376.449 67.0812 376.953 68.2916 377.508 70.0064C377.508 70.0568 377.508 70.0568 377.558 70.1073C377.911 71.3177 377.861 72.629 377.709 74.0916C377.558 75.2011 376.751 77.0167 376.247 77.9245C376.196 78.0254 376.196 78.2271 376.247 78.3785C376.297 78.4793 376.348 78.5298 376.398 78.5802L378.214 79.2358L378.617 79.3871C378.92 79.488 379.223 79.4376 379.475 79.2863C379.676 79.135 379.828 78.9332 379.828 78.6811C380.231 75.6046 380.736 72.4272 381.139 71.2672C382.904 66.0221 380.433 62.1387 380.433 62.1387C380.433 62.1387 377.558 62.3404 377.003 62.5421Z",
    fill: "#EDDAD3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M386.238 82.4147L389.063 74.6982L398.242 74.8495L395.518 81.9608L386.238 82.4147Z",
    fill: "#6E6760"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M391.985 78.1275C391.682 78.6823 391.783 79.2875 392.186 79.4893C392.59 79.691 393.094 79.3884 393.397 78.8336C393.699 78.2788 393.598 77.6736 393.195 77.4719C392.842 77.2702 392.287 77.5727 391.985 78.1275Z",
    fill: "#807066"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M382.356 56.9956C382.356 56.9956 382.961 57.9035 382.406 58.7104C381.851 59.5174 382.557 60.2739 382.658 61.0808C382.759 61.8878 380.389 64.1069 383.062 65.2164C385.684 66.326 386.542 64.5103 385.886 63.5016C385.23 62.493 384.726 61.686 384.676 60.2234C384.575 58.7608 384.121 56.5417 382.356 56.9956Z",
    fill: "#464240"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M369.441 53.2139H374.989V57.1982V58.0555L374.132 57.1982H369.441V53.2139Z",
    fill: "#FFCB55"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M288.084 114.489C288.084 114.489 276.081 125.938 281.931 134.814C287.782 143.691 290.505 135.924 290.505 135.924C290.505 135.924 294.439 137.134 288.589 126.14C285.815 120.995 288.084 114.489 288.084 114.489Z",
    fill: "#BBD070"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M265.902 102.085C265.902 102.085 256.723 112.878 268.979 127.806C281.234 142.735 279.368 150.653 279.368 150.653C279.368 150.653 296.415 124.679 265.902 102.085Z",
    fill: "#97A43C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M282.081 146.111C287.78 147.271 283.191 130.678 274.617 125.584C266.043 120.541 258.377 120.037 253.586 115.145C253.636 115.195 253.989 140.462 282.081 146.111Z",
    fill: "#48753A"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7969 153.424C44.7969 153.424 45.049 152.768 45.0995 152.667C45.1499 152.566 45.4021 152.415 45.7047 152.264C46.0073 152.112 46.5116 152.012 46.5621 152.062C46.6125 152.112 46.6629 152.112 46.7638 152.213C46.8143 152.365 46.8142 152.516 46.8142 152.516C46.8142 152.516 46.9655 152.667 46.9151 152.818C46.9151 152.818 47.0664 152.97 46.9656 153.172C46.9656 153.172 47.1169 153.323 47.016 153.424C47.016 153.424 46.7638 153.575 46.6629 153.676C46.5621 153.777 46.0577 154.079 45.4525 154.281C45.503 154.281 44.8977 154.281 44.7969 153.424Z",
    fill: "#EEA886"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6974 153.072C45.6974 153.072 45.6974 153.425 45.6469 153.526C45.5965 153.627 46.353 153.829 46.353 153.829C46.353 153.829 46.1513 153.072 45.6974 153.072Z",
    fill: "#CF8C6C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5312 187.366L31.8843 186.357L33.246 186.559L33.0443 187.517L31.5312 187.366Z",
    fill: "#3B3F66"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0273 187.269L43.1282 187.823L44.6412 187.571L44.5908 186.714L43.0273 187.269Z",
    fill: "#555C94"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7051 171.329C39.7051 171.329 39.5034 172.539 39.2008 173.951C39.1504 174.203 39.0999 174.456 39.0495 174.657C38.7973 175.969 38.5452 177.23 38.4443 177.532C38.2426 178.137 33.5017 186.762 33.5017 186.762C33.5017 186.762 31.5852 186.61 31.4844 186.358C31.4844 186.358 35.4182 176.977 35.4182 176.675C35.4182 176.322 35.9226 166.739 35.9226 166.739C35.9226 166.739 39.6043 170.774 39.7051 171.329Z",
    fill: "#354C70"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8762 166.132C41.8762 166.132 43.7423 175.564 43.8936 176.27C44.0449 176.976 44.751 186.659 44.751 186.659C44.751 186.659 44.3475 187.517 42.7841 187.214C42.7841 187.214 40.7163 176.825 40.5145 176.471C39.8084 175.11 36.4798 168.604 36.1772 167.646C35.8746 166.687 35.925 165.628 35.925 165.628C35.925 165.628 38.3963 164.216 41.8762 166.132Z",
    fill: "#354C70"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M41.068 153.929C41.068 153.929 41.875 155.946 42.0767 155.896C42.2785 155.846 44.5984 153.122 44.5984 153.122C44.5984 153.122 45.6575 154.433 45.5062 154.585C45.3045 154.786 42.5811 159.376 42.1776 159.275C41.8246 159.174 40.1098 156.4 40.1098 156.4C40.1098 156.4 40.0594 154.282 41.068 153.929Z",
    fill: "#DEB135"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6374 150.096C37.6374 150.096 39.7557 151.71 40.3104 152.315C40.8652 152.97 42.4791 155.593 42.3782 156.4C41.9243 159.426 41.7226 162.049 41.7226 164.116C41.7226 165.932 42.2774 166.386 41.9243 166.386C41.5209 166.436 36.2253 168.302 35.4688 168.555C35.4688 168.555 35.9731 162.2 36.2253 161.443C36.4774 160.737 35.3679 153.021 37.6374 150.096Z",
    fill: "#F2C344"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1084 147.072L51.5623 149.443L52.0162 151.813C52.0162 151.813 49.3432 150.956 46.2668 151.561L46.065 150.502L45.8633 149.443C48.9398 148.837 51.1084 147.072 51.1084 147.072Z",
    fill: "#D9D0C4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1336 187.824C43.1336 187.824 44.2936 187.622 44.344 187.571C44.3944 187.521 44.6466 187.067 44.7979 187.168C44.9997 187.269 44.9997 187.824 45.151 187.924C45.3023 188.025 46.7144 188.933 46.8657 189.135C47.017 189.286 48.0761 189.185 48.2274 189.488C48.3283 189.79 48.3787 190.497 46.8153 190.295C45.2518 190.143 43.4866 190.396 43.1336 190.194C42.7301 189.992 43.0327 188.277 43.1336 187.824Z",
    fill: "#84BDFF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M31.523 187.369C31.523 187.369 32.683 187.318 32.7334 187.318C32.7838 187.268 33.0864 186.864 33.2377 186.965C33.389 187.066 33.3386 187.621 33.4899 187.722C33.6412 187.823 34.8516 188.983 35.0029 189.184C35.1542 189.386 36.2134 189.437 36.2638 189.739C36.3142 190.042 36.2134 190.748 34.7003 190.344C33.1873 189.941 31.3717 189.891 31.0691 189.638C30.8169 189.437 31.3213 187.772 31.523 187.369Z",
    fill: "#84BDFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6596 166.59C40.6596 166.59 40.8109 167.145 41.0127 167.296C41.2144 167.397 39.9536 168.658 39.9536 168.658C39.9536 168.658 39.4492 167.498 39.4492 167.397C39.4997 167.245 40.6596 166.59 40.6596 166.59Z",
    fill: "#EEA987"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6742 152.569C36.6742 152.569 35.1611 159.731 35.0603 160.437C34.9594 161.143 39.448 167.75 39.448 167.75L40.9611 166.842C40.9611 166.842 37.3298 160.185 37.3298 159.882C37.3298 159.579 39.095 153.83 39.095 153.83C39.095 153.83 39.8011 152.569 38.5402 151.964C37.2289 151.409 36.6742 152.569 36.6742 152.569Z",
    fill: "#FFD255"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5688 167.095C41.5688 167.095 42.0732 169.516 42.0227 170.272C41.9723 171.029 39.1984 169.112 39.3497 168.356L41.5688 167.095Z",
    fill: "#3C5780"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6289 150.099C37.6289 150.099 41.4619 154.285 41.2097 153.781C40.3524 152.117 39.7976 151.864 39.7976 151.562C39.7976 151.31 39.8984 150.654 39.8984 150.402C39.9489 149.948 39.9489 149.595 39.9489 149.595C39.9489 149.595 38.0324 146.922 38.1332 147.83C38.2341 148.788 37.6289 150.099 37.6289 150.099Z",
    fill: "#EEA886"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2642 145.207C41.2642 145.207 41.7686 146.417 41.819 146.72C41.819 147.023 41.7686 147.224 41.819 147.577C41.8695 147.93 42.1721 148.636 42.1216 148.838C42.0712 149.09 41.5668 148.939 41.5164 149.343C41.466 149.746 41.0625 150.503 40.9112 150.503C40.4573 150.553 38.6417 149.796 38.4904 149.443C38.3895 149.04 37.7339 146.972 37.5321 146.569C37.3304 146.165 40.7095 143.946 41.0121 144.602C41.2642 145.207 41.2642 145.207 41.2642 145.207Z",
    fill: "#EEA886"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6752 146.111C36.423 145.052 37.6334 144.951 37.6334 144.951C37.6334 144.951 38.4404 144.044 40.3064 144.145C42.1725 144.245 41.8699 146.717 41.8699 146.717C41.8699 146.717 40.5586 146.515 40.0038 146.666C40.0038 146.666 39.9534 147.725 40.0038 147.978L39.2978 147.927C39.2978 147.927 39.3986 147.019 39.0456 146.969C38.6925 146.918 38.5917 148.936 37.9865 149.39C37.9865 149.39 37.9865 149.238 37.8856 149.087C37.7847 148.885 37.583 148.482 37.3813 148.078C37.0787 147.372 36.7761 146.616 36.6752 146.111Z",
    fill: "#16202E"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4982 147.12C39.4982 147.12 39.246 146.414 38.5904 146.868C38.1365 147.221 38.5904 148.381 39.0443 148.381C39.4982 148.381 39.6999 147.725 39.4982 147.12Z",
    fill: "#EEA886"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3405 149.088C38.3405 149.088 38.4413 149.441 38.5422 149.542C38.6431 149.643 39.097 149.996 39.9544 150.298L39.9039 151.055C39.8535 151.004 38.2396 150.399 38.3405 149.088Z",
    fill: "#C48A6F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1442 151.408H45.0938V154.233H45.1442V151.408Z",
    fill: "#96CBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.195 151.408H45.1445V154.233H45.195V151.408Z",
    fill: "#95CAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.195 151.408H45.1445V154.233H45.195V151.408Z",
    fill: "#94C9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2457 151.408H45.1953V154.233H45.2457V151.408Z",
    fill: "#93C9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2965 151.408H45.2461V154.233H45.2965V151.408Z",
    fill: "#92C8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2965 151.408H45.2461V154.233H45.2965V151.408Z",
    fill: "#91C7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3473 151.408H45.2969V154.233H45.3473V151.408Z",
    fill: "#90C6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3473 151.408H45.2969V154.233H45.3473V151.408Z",
    fill: "#8FC6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3942 151.408H45.3438V154.233H45.3942V151.408Z",
    fill: "#8EC5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3942 151.408H45.3438V154.233H45.3942V151.408Z",
    fill: "#8DC4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4489 151.408H45.3984V154.233H45.4489V151.408Z",
    fill: "#8CC3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4997 151.408H45.4492V154.233H45.4997V151.408Z",
    fill: "#8BC2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4997 151.408H45.4492V154.233H45.4997V151.408Z",
    fill: "#8AC2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5504 151.408H45.5V154.233H45.5504V151.408Z",
    fill: "#89C1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5504 151.408H45.5V154.233H45.5504V151.408Z",
    fill: "#88C0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6012 151.408H45.5508V154.233H45.6012V151.408Z",
    fill: "#87BFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6481 151.408H45.5977V154.233H45.6481V151.408Z",
    fill: "#86BFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6481 151.408H45.5977V154.233H45.6481V151.408Z",
    fill: "#85BEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6989 151.408H45.6484V154.233H45.6989V151.408Z",
    fill: "#84BDFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6989 151.408H45.6484V154.233H45.6989V151.408Z",
    fill: "#83BCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7497 151.408H45.6992V154.233H45.7497V151.408Z",
    fill: "#82BBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7497 151.408H45.6992V154.233H45.7497V151.408Z",
    fill: "#81BBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8043 151.408H45.7539V154.233H45.8043V151.408Z",
    fill: "#80BAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8512 151.408H45.8008V154.233H45.8512V151.408Z",
    fill: "#7FB9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8512 151.408H45.8008V154.233H45.8512V151.408Z",
    fill: "#7EB8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.902 151.408H45.8516V154.233H45.902V151.408Z",
    fill: "#7DB7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.902 151.408H45.8516V154.233H45.902V151.408Z",
    fill: "#7CB7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9528 151.408H45.9023V154.233H45.9528V151.408Z",
    fill: "#7BB6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9528 151.408H45.9023V154.233H45.9528V151.408Z",
    fill: "#7AB5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0036 151.408H45.9531V154.233H46.0036V151.408Z",
    fill: "#79B4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0543 151.408H46.0039V154.233H46.0543V151.408Z",
    fill: "#78B4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0543 151.408H46.0039V154.233H46.0543V151.408Z",
    fill: "#77B3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1012 151.408H46.0508V154.233H46.1012V151.408Z",
    fill: "#76B2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1012 151.408H46.0508V154.233H46.1012V151.408Z",
    fill: "#74B1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.152 151.408H46.1016V154.233H46.152V151.408Z",
    fill: "#73B0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2067 151.408H46.1562V154.233H46.2067V151.408Z",
    fill: "#72B0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2067 151.408H46.1562V154.233H46.2067V151.408Z",
    fill: "#71AFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2536 151.408H46.2031V154.233H46.2536V151.408Z",
    fill: "#70AEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2536 151.408H46.2031V154.233H46.2536V151.408Z",
    fill: "#6FADFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3043 151.408H46.2539V154.233H46.3043V151.408Z",
    fill: "#6EADFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3043 151.408H46.2539V154.233H46.3043V151.408Z",
    fill: "#6DACFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3551 151.408H46.3047V154.233H46.3551V151.408Z",
    fill: "#6CABFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4059 151.408H46.3555V154.233H46.4059V151.408Z",
    fill: "#6BAAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4059 151.408H46.3555V154.233H46.4059V151.408Z",
    fill: "#6AA9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4567 151.408H46.4062V154.233H46.4567V151.408Z",
    fill: "#69A9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4567 151.408H46.4062V154.233H46.4567V151.408Z",
    fill: "#68A8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5075 151.408H46.457V154.233H46.5075V151.408Z",
    fill: "#67A7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5582 151.408H46.5078V154.233H46.5582V151.408Z",
    fill: "#66A6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5582 151.408H46.5078V154.233H46.5582V151.408Z",
    fill: "#65A6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6051 151.408H46.5547V154.233H46.6051V151.408Z",
    fill: "#64A5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6051 151.408H46.5547V154.233H46.6051V151.408Z",
    fill: "#63A4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6598 151.408H46.6094V154.233H46.6598V151.408Z",
    fill: "#62A3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6598 151.408H46.6094V154.233H46.6598V151.408Z",
    fill: "#61A2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7106 151.408H46.6602V154.233H46.7106V151.408Z",
    fill: "#60A2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7614 151.408H46.7109V154.233H46.7614V151.408Z",
    fill: "#5FA1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7614 151.408H46.7109V154.233H46.7614V151.408Z",
    fill: "#5EA0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8082 151.408H46.7578V154.233H46.8082V151.408Z",
    fill: "#5D9FFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8082 151.408H46.7578V154.233H46.8082V151.408Z",
    fill: "#5C9EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.859 151.408H46.8086V154.233H46.859V151.408Z",
    fill: "#5B9EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.859 151.408H46.8086V154.233H46.859V151.408Z",
    fill: "#5A9DFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9098 151.408H46.8594V154.233H46.9098V151.408Z",
    fill: "#599CFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9645 151.408H46.9141V154.233H46.9645V151.408Z",
    fill: "#589BFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9645 151.408H46.9141V154.233H46.9645V151.408Z",
    fill: "#579BFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0114 151.408H46.9609V154.233H47.0114V151.408Z",
    fill: "#569AFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 151,
    width: 3,
    height: 4
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7581 154.132L47.0103 153.98L45.7998 151.408L45.0938 151.711L46.1529 153.93C46.2537 154.182 46.5059 154.233 46.7581 154.132Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0114 151.408H46.9609V154.233H47.0114V151.408Z",
    fill: "#5599FF"
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M46.454 152.063C46.454 152.063 45.6975 152.467 45.7479 152.618C45.7983 152.77 45.8992 152.77 45.8992 152.77L45.647 153.072C45.647 153.072 45.5966 153.375 45.9496 153.324C45.9496 153.324 45.8992 153.576 46.2018 153.526C46.2018 153.526 46.2522 153.728 46.4035 153.728C46.5548 153.728 47.0592 153.425 47.0592 153.425C47.0592 153.425 47.1096 153.324 47.0087 153.173C47.0087 153.173 47.1096 152.971 46.9583 152.82C46.9583 152.82 47.0087 152.669 46.8574 152.517C46.8574 152.517 46.9079 152.164 46.6053 152.063C46.5044 152.063 46.454 152.063 46.454 152.063Z",
    fill: "#DB9C7C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8278 149.287H43.7773V152.011H43.8278V149.287Z",
    fill: "#96CBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8825 149.287H43.832V152.011H43.8825V149.287Z",
    fill: "#95CAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9332 149.287H43.8828V152.011H43.9332V149.287Z",
    fill: "#94C9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9801 149.287H43.9297V152.011H43.9801V149.287Z",
    fill: "#93C9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0309 149.287H43.9805V152.011H44.0309V149.287Z",
    fill: "#92C8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0817 149.287H44.0312V152.011H44.0817V149.287Z",
    fill: "#91C7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1325 149.287H44.082V152.011H44.1325V149.287Z",
    fill: "#90C6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1832 149.287H44.1328V152.011H44.1832V149.287Z",
    fill: "#8FC6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.234 149.287H44.1836V152.011H44.234V149.287Z",
    fill: "#8EC5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2809 149.287H44.2305V152.011H44.2809V149.287Z",
    fill: "#8DC4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3356 149.287H44.2852V152.011H44.3356V149.287Z",
    fill: "#8CC3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3864 149.287H44.3359V152.011H44.3864V149.287Z",
    fill: "#8BC2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3864 149.287H44.3359V152.011H44.3864V149.287Z",
    fill: "#8AC2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4332 149.287H44.3828V152.011H44.4332V149.287Z",
    fill: "#89C1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.484 149.287H44.4336V152.011H44.484V149.287Z",
    fill: "#88C0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5348 149.287H44.4844V152.011H44.5348V149.287Z",
    fill: "#87BFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5856 149.287H44.5352V152.011H44.5856V149.287Z",
    fill: "#86BFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6364 149.287H44.5859V152.011H44.6364V149.287Z",
    fill: "#85BEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6832 149.287H44.6328V152.011H44.6832V149.287Z",
    fill: "#84BDFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7379 149.287H44.6875V152.011H44.7379V149.287Z",
    fill: "#83BCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7887 149.287H44.7383V152.011H44.7887V149.287Z",
    fill: "#82BBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8395 149.287H44.7891V152.011H44.8395V149.287Z",
    fill: "#81BBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8864 149.287H44.8359V152.011H44.8864V149.287Z",
    fill: "#80BAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9372 149.287H44.8867V152.011H44.9372V149.287Z",
    fill: "#7FB9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9879 149.287H44.9375V152.011H44.9879V149.287Z",
    fill: "#7EB8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0387 149.287H44.9883V152.011H45.0387V149.287Z",
    fill: "#7DB7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0934 149.287H45.043V152.011H45.0934V149.287Z",
    fill: "#7CB7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1403 149.287H45.0898V152.011H45.1403V149.287Z",
    fill: "#7BB6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1911 149.287H45.1406V152.011H45.1911V149.287Z",
    fill: "#7AB5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2418 149.287H45.1914V152.011H45.2418V149.287Z",
    fill: "#79B4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2926 149.287H45.2422V152.011H45.2926V149.287Z",
    fill: "#78B4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2926 149.287H45.2422V152.011H45.2926V149.287Z",
    fill: "#77B3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3434 149.287H45.293V152.011H45.3434V149.287Z",
    fill: "#76B2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3942 149.287H45.3438V152.011H45.3942V149.287Z",
    fill: "#74B1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4411 149.287H45.3906V152.011H45.4411V149.287Z",
    fill: "#73B0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4957 149.287H45.4453V152.011H45.4957V149.287Z",
    fill: "#72B0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5426 149.287H45.4922V152.011H45.5426V149.287Z",
    fill: "#71AFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5934 149.287H45.543V152.011H45.5934V149.287Z",
    fill: "#70AEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6442 149.287H45.5938V152.011H45.6442V149.287Z",
    fill: "#6FADFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.695 149.287H45.6445V152.011H45.695V149.287Z",
    fill: "#6EADFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7457 149.287H45.6953V152.011H45.7457V149.287Z",
    fill: "#6DACFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7965 149.287H45.7461V152.011H45.7965V149.287Z",
    fill: "#6CABFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8434 149.287H45.793V152.011H45.8434V149.287Z",
    fill: "#6BAAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8981 149.287H45.8477V152.011H45.8981V149.287Z",
    fill: "#6AA9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9489 149.287H45.8984V152.011H45.9489V149.287Z",
    fill: "#69A9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9997 149.287H45.9492V152.011H45.9997V149.287Z",
    fill: "#68A8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0504 149.287H46V152.011H46.0504V149.287Z",
    fill: "#67A7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0973 149.287H46.0469V152.011H46.0973V149.287Z",
    fill: "#66A6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1481 149.287H46.0977V152.011H46.1481V149.287Z",
    fill: "#65A6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1989 149.287H46.1484V152.011H46.1989V149.287Z",
    fill: "#64A5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2536 149.287H46.2031V152.011H46.2536V149.287Z",
    fill: "#63A4FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2536 149.287H46.2031V152.011H46.2536V149.287Z",
    fill: "#62A3FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3004 149.287H46.25V152.011H46.3004V149.287Z",
    fill: "#61A2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3512 149.287H46.3008V152.011H46.3512V149.287Z",
    fill: "#60A2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.402 149.287H46.3516V152.011H46.402V149.287Z",
    fill: "#5FA1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4528 149.287H46.4023V152.011H46.4528V149.287Z",
    fill: "#5EA0FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5036 149.287H46.4531V152.011H46.5036V149.287Z",
    fill: "#5D9FFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5504 149.287H46.5V152.011H46.5504V149.287Z",
    fill: "#5C9EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6012 149.287H46.5508V152.011H46.6012V149.287Z",
    fill: "#5B9EFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6559 149.287H46.6055V152.011H46.6559V149.287Z",
    fill: "#5A9DFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7067 149.287H46.6562V152.011H46.7067V149.287Z",
    fill: "#599CFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7536 149.287H46.7031V152.011H46.7536V149.287Z",
    fill: "#589BFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8043 149.287H46.7539V152.011H46.8043V149.287Z",
    fill: "#579BFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8551 149.287H46.8047V152.011H46.8551V149.287Z",
    fill: "#569AFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_1046_17454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 149,
    width: 4,
    height: 3
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1808 151.96L46.9043 151.456L46.4504 149.287L43.7773 149.892L44.1808 151.96Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_1046_17454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9059 149.287H46.8555V152.011H46.9059V149.287Z",
    fill: "#5599FF"
  }))), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0991 152.668C45.0991 152.668 45.7043 152.668 46.0069 152.769C46.0574 152.819 46.1582 152.819 46.1582 152.92C46.1582 153.021 46.0574 153.122 45.8052 153.122C45.553 153.122 45.2 153.273 45.2 153.273C45.2 153.273 44.9478 153.223 45.0991 152.668Z",
    fill: "#EEA886"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1995 173.953C39.1491 174.205 39.0986 174.457 39.0482 174.659L37.5352 170.624C37.7369 171.027 39.1995 173.953 39.1995 173.953Z",
    fill: "#293B57"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9486 125.737H39.8411C38.0759 125.737 36.6133 124.275 36.6133 122.51V84.4319C36.6133 82.6667 38.0759 81.2041 39.8411 81.2041H63.9486C65.7138 81.2041 67.1763 82.6667 67.1763 84.4319V122.51C67.1259 124.275 65.7138 125.737 63.9486 125.737Z",
    fill: "#FFC955"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8955 109.953H62.332V122.007H63.8955V109.953Z",
    fill: "#E3F2FF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7744 111.314H59.2109V122.006H60.7744V111.314Z",
    fill: "#E3F2FF"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3408 113.078H55.7773V122.005H57.3408V113.078Z",
    fill: "#E3F2FF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8603 115.298H52.2969V122.006H53.8603V115.298Z",
    fill: "#E3F2FF"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8648 113.836L42.5117 113.735L45.4873 105.363L51.9429 103.649L54.3133 94.4192L59.3063 92.2505L60.4158 85.0889L60.7689 85.1393L59.6089 92.5027L54.6159 94.6713L52.2455 103.951L45.7899 105.666L42.8648 113.836Z",
    fill: "#E3F2FF"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8502 103.144C53.2032 103.547 53.1528 104.152 52.6989 104.505C52.2954 104.858 51.6902 104.808 51.3371 104.354C50.9841 103.951 51.0345 103.345 51.4885 102.992C51.8919 102.69 52.5476 102.74 52.8502 103.144Z",
    fill: "#FFC955"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8594 104.656C52.3551 105.06 51.649 105.009 51.2455 104.505C50.8421 104.001 50.8925 103.295 51.3968 102.891C51.9012 102.488 52.6073 102.538 53.0107 103.042C53.4142 103.547 53.3638 104.253 52.8594 104.656ZM51.5986 103.143C51.2455 103.395 51.1951 103.9 51.4977 104.253C51.7499 104.606 52.2542 104.656 52.6073 104.354C52.9603 104.101 53.0107 103.597 52.7081 103.244C52.456 102.941 51.9516 102.891 51.5986 103.143Z",
    fill: "#E3F2FF"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2213 94.0146C55.5743 94.4181 55.5239 95.0233 55.07 95.3763C54.6665 95.7294 54.0613 95.6789 53.7082 95.225C53.3552 94.8215 53.4056 94.2163 53.8595 93.8633C54.263 93.5103 54.8682 93.6111 55.2213 94.0146Z",
    fill: "#FFC955"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2266 95.5283C54.7223 95.9318 54.0162 95.8814 53.6127 95.377C53.2093 94.8727 53.2597 94.1666 53.764 93.7631C54.2684 93.3596 54.9745 93.4101 55.3779 93.9144C55.7814 94.3683 55.6805 95.1248 55.2266 95.5283ZM53.9658 94.0153C53.6127 94.2675 53.5623 94.7718 53.8649 95.1248C54.1171 95.4779 54.6214 95.5283 54.9745 95.2257C55.3275 94.9735 55.3779 94.4692 55.0753 94.1162C54.8231 93.7631 54.3188 93.7127 53.9658 94.0153Z",
    fill: "#E3F2FF"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1666 91.7451C60.5196 92.1485 60.4692 92.7538 60.0153 93.1068C59.6118 93.4598 59.0066 93.4094 58.6536 92.9555C58.3005 92.552 58.351 91.9468 58.8049 91.5938C59.2083 91.2407 59.8135 91.3416 60.1666 91.7451Z",
    fill: "#FFC955"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1094 93.2588C59.6051 93.6623 58.899 93.6118 58.4955 93.1075C58.0921 92.6031 58.1425 91.8971 58.6468 91.4936C59.1512 91.0901 59.8573 91.1406 60.2607 91.6449C60.6642 92.0988 60.6138 92.8553 60.1094 93.2588ZM58.899 91.7458C58.546 91.9979 58.4955 92.5023 58.7982 92.8553C59.0503 93.2084 59.5547 93.2588 59.9077 92.9562C60.2607 92.704 60.3112 92.1997 60.0086 91.8466C59.706 91.4936 59.2521 91.4432 58.899 91.7458Z",
    fill: "#E3F2FF"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M46.401 104.959C46.754 105.363 46.7036 105.968 46.2497 106.321C45.8462 106.674 45.241 106.623 44.8879 106.17C44.5349 105.716 44.5853 105.161 45.0392 104.808C45.4427 104.505 46.0983 104.556 46.401 104.959Z",
    fill: "#FFC955"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3985 106.472C45.8942 106.875 45.1881 106.825 44.7846 106.32C44.3811 105.816 44.4316 105.11 44.9359 104.706C45.4403 104.303 46.1463 104.353 46.5498 104.858C46.9533 105.362 46.9028 106.068 46.3985 106.472ZM45.1881 104.959C44.835 105.211 44.7846 105.715 45.0872 106.068C45.3394 106.421 45.8437 106.472 46.1968 106.169C46.5498 105.917 46.6002 105.413 46.2976 105.06C45.995 104.757 45.4907 104.706 45.1881 104.959Z",
    fill: "#E3F2FF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8715 95.8299H40.5498C40.1464 95.8299 39.8438 95.5273 39.8438 95.1238V94.5186C39.8438 94.1151 40.1464 93.8125 40.5498 93.8125H48.8715C49.2749 93.8125 49.5775 94.1151 49.5775 94.5186V95.1238C49.5775 95.5273 49.2245 95.8299 48.8715 95.8299Z",
    fill: "#EBEBEB"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8715 92.3015H40.5498C40.1464 92.3015 39.8438 91.9989 39.8438 91.5955V90.9903C39.8438 90.5868 40.1464 90.2842 40.5498 90.2842H48.8715C49.2749 90.2842 49.5775 90.5868 49.5775 90.9903V91.5955C49.5775 91.9989 49.2245 92.3015 48.8715 92.3015Z",
    fill: "#EBEBEB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8347 97.4434C32.8347 97.4434 32.5321 100.217 33.0869 100.923C33.0869 100.923 31.7251 100.621 31.4225 100.167C31.1199 99.7129 32.8347 97.4434 32.8347 97.4434Z",
    fill: "#16202E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3543 106.371C41.3543 106.371 41.8587 106.018 41.9091 105.968C42.01 105.917 42.2621 105.917 42.5143 105.968C42.8169 106.018 43.17 106.169 43.2204 106.22C43.2204 106.27 43.2708 106.321 43.2708 106.421C43.2708 106.573 43.17 106.623 43.17 106.623C43.17 106.623 43.2204 106.774 43.1195 106.926C43.1195 106.926 43.17 107.077 43.0186 107.178C43.0186 107.178 43.0691 107.329 42.9178 107.38C42.9178 107.38 42.6656 107.38 42.5647 107.38C42.4639 107.38 41.9595 107.329 41.4552 107.228C41.4552 107.279 40.9004 107.178 41.3543 106.371Z",
    fill: "#EEA886"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M42.16 106.572C42.16 106.572 42.0087 106.824 41.9079 106.875C41.807 106.925 42.3113 107.43 42.3113 107.43C42.3113 107.43 42.5131 106.774 42.16 106.572Z",
    fill: "#CF8C6C"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0475 106.419C41.0475 106.419 41.3501 106.369 41.5518 106.318C41.7536 106.217 41.5014 107.277 41.5014 107.277C41.5014 107.277 41.0475 106.974 40.7449 106.924C40.4423 106.924 41.0475 106.419 41.0475 106.419Z",
    fill: "#EEA886"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1878 134.513C28.1878 134.513 29.146 135.925 29.499 136.227C29.499 136.227 30.1547 136.58 30.2051 136.883C30.2555 137.438 30.2556 137.74 29.3982 137.74C28.4904 137.74 27.9356 137.74 27.7843 137.186C27.633 136.631 27.3304 136.227 27.3304 136.227L27.2799 137.64H27.0782C27.0782 137.64 26.9773 136.227 26.9773 136.026C26.9773 135.824 26.826 135.067 27.2799 134.714C27.633 134.361 28.1878 134.513 28.1878 134.513Z",
    fill: "#162D40"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5998 136.328C29.5998 136.328 29.0955 136.479 28.5407 136.328C27.9859 136.177 27.4312 134.815 27.2294 134.714L27.0781 134.159H28.1877C28.1877 134.159 28.1877 134.563 28.3894 134.916C28.5911 135.218 29.5998 136.328 29.5998 136.328Z",
    fill: "#162D40"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4985 134.008C34.4985 134.008 34.6498 134.361 34.902 134.715C35.1037 134.967 35.709 136.076 36.0116 136.127C36.2637 136.177 37.1211 136.328 37.222 136.833C37.2724 137.287 37.3228 137.64 36.5159 137.69C35.6585 137.741 35.1037 137.791 34.7003 137.186C34.2968 136.581 33.6412 136.177 33.6412 136.177V137.741H33.3386C33.3386 137.741 33.1873 136.127 33.0864 136.026C32.9855 135.925 32.7838 134.664 33.5403 134.059C34.3472 133.353 34.4985 134.008 34.4985 134.008Z",
    fill: "#162D40"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M36.005 136.126C36.005 136.126 35.2485 136.328 34.9459 136.126C34.6433 135.925 33.6851 134.26 33.332 134.159C33.332 134.159 33.6346 133.504 34.4416 134.008C34.492 134.008 35.8033 135.824 36.005 136.126Z",
    fill: "#162D40"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7357 110.959C27.7357 110.959 26.6766 112.32 26.3739 113.985C26.0713 115.599 26.5253 121.146 26.5253 121.953C26.5253 122.76 25.8192 125.282 25.9705 126.795C26.1218 128.308 26.9287 134.663 26.9287 134.663L28.7443 134.612C28.7443 134.612 28.3913 127.753 28.4922 127.097C28.593 126.442 28.8957 123.718 28.9461 123.466C28.9965 123.214 31.0643 116.254 31.0643 115.044C31.0643 113.833 30.3078 108.992 27.7357 110.959Z",
    fill: "#1D3B54"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0785 111.465C33.0785 111.465 34.8437 118.122 35.0454 119.03C35.2472 119.938 35.6506 121.148 35.6506 121.35C35.6506 121.501 35.4489 124.376 35.4489 124.376L34.9446 134.06H33.1289C33.1289 134.06 32.5237 127.907 32.4229 126.646C32.322 125.385 33.0785 123.468 32.9272 122.964C32.7255 122.46 29.9012 116.357 29.9012 116.357C29.9012 116.357 27.6821 109.549 33.0785 111.465Z",
    fill: "#1D3B54"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5256 101.528C32.5256 101.528 33.2317 101.579 33.736 102.184C34.2404 102.739 34.7447 103.647 34.896 103.949C35.0473 104.252 36.9638 107.026 37.0647 107.127C37.1656 107.177 38.0229 106.975 38.6786 106.925C39.7881 106.824 41.4525 106.269 41.4525 106.269L41.7046 107.53C41.7046 107.53 37.6195 108.841 36.7117 108.589C35.5517 108.286 32.9291 104.907 32.9291 104.907C32.9291 104.907 30.9622 102.537 32.5256 101.528Z",
    fill: "#EDDAD3"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3186 101.023C31.3186 101.023 32.2264 101.427 32.529 101.528C32.8316 101.578 34.042 103.192 34.2942 103.747C34.4959 104.301 34.2942 105.209 33.8403 106.218C33.3864 107.227 33.8403 107.58 33.6386 108.588C33.4368 109.597 33.4368 112.371 33.4872 112.926C33.5377 113.48 27.6873 114.54 26.5273 113.531C26.5273 113.531 27.3343 110.908 28.2421 109.95C28.4438 109.748 28.4438 108.336 28.2925 107.983C28.1412 107.63 26.5778 105.007 26.5778 105.007C26.5778 105.007 26.4769 102.334 27.1326 101.83C27.7378 101.376 29.3517 101.225 29.6038 101.124C29.9064 100.973 30.7134 100.922 31.3186 101.023Z",
    fill: "#EDDAD3"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 103.042L32.1785 102.387L31.7246 100.672C31.6742 100.672 31.5229 101.63 31.6238 103.042Z",
    fill: "#D1C0BA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1956 101.527C28.1956 101.527 27.0356 101.224 26.38 102.435C25.7243 103.695 25.8756 104.351 25.7243 104.956C25.573 105.511 24.9678 109.294 24.9174 109.445C24.867 109.596 24.3122 111.513 24.3626 112.118C24.413 112.723 24.9678 117.161 24.9678 117.313C24.9678 117.464 26.0269 117.161 26.0269 117.161C26.0269 117.161 25.9765 112.622 26.0269 112.219C26.0774 111.866 26.0774 109.848 26.38 109.344C26.6826 108.84 27.3382 105.713 27.4895 105.41C27.6913 105.108 29.1539 101.93 28.1956 101.527Z",
    fill: "#EEA886"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7741 99.965C31.7741 99.965 31.5724 101.629 31.6228 102.184C31.6228 102.184 30.6646 103.142 29.6055 101.075C29.6055 101.075 30.0594 100.217 29.7063 99.1077C29.4037 97.9477 31.7741 99.965 31.7741 99.965Z",
    fill: "#EEA886"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6181 102.182V103.04L30.6094 102.132L31.6181 102.182Z",
    fill: "#EEA886"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6233 103.042L31.1694 102.488L29.6563 100.975L29.1016 101.227L31.6233 103.042Z",
    fill: "#D1C0BA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1762 102.387L32.8319 102.588L31.6719 100.672L32.1762 102.387Z",
    fill: "#FAE6DE"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M31.169 102.486L30.5134 103.495L29.0508 101.175L29.7064 100.872L31.169 102.486Z",
    fill: "#FAE6DE"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3953 106.572C34.3953 106.572 34.5971 105.059 34.3953 104.151C34.3953 104.151 34.244 104.908 33.9414 106.017L34.3953 106.572Z",
    fill: "#D1C0BA"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3789 106.37C27.3789 106.37 27.9841 104.302 28.0346 104.201C28.0346 104.201 27.9841 106.118 27.7319 107.025C27.7319 107.025 27.5302 106.622 27.3789 106.37Z",
    fill: "#D1C0BA"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6315 95.9805L40.7969 108.387L41.1499 108.639L50.6315 95.9805Z",
    fill: "#54281A"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1709 106.219C43.1709 106.219 42.4144 106.169 42.4144 106.27C42.3639 106.371 42.4648 106.421 42.4648 106.421L42.1622 106.522C42.1622 106.522 42.0109 106.724 42.2631 106.825C42.2631 106.825 42.1118 106.976 42.3639 107.077C42.3639 107.077 42.3135 107.228 42.4144 107.279C42.5152 107.329 43.0196 107.379 43.0196 107.379C43.0196 107.379 43.1204 107.329 43.1204 107.178C43.1204 107.178 43.2718 107.077 43.2213 106.925C43.2213 106.925 43.3222 106.825 43.2718 106.623C43.2718 106.623 43.5239 106.371 43.3222 106.169C43.2213 106.219 43.1709 106.219 43.1709 106.219Z",
    fill: "#DB9C7C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9592 105.966C41.9592 105.966 42.4131 106.218 42.5644 106.47C42.6148 106.521 42.6148 106.571 42.6148 106.621C42.5644 106.672 42.4635 106.672 42.2618 106.571C42.0601 106.47 41.7575 106.42 41.7575 106.42C41.7575 106.42 41.5557 106.319 41.9592 105.966Z",
    fill: "#EEA886"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0109 94.3165C31.0109 94.3165 32.6752 94.2661 32.9778 96.233C33.2804 98.2 32.5744 99.9147 32.3222 100.217C32.0196 100.52 30.4057 100.268 30.0022 99.2591C29.5988 98.2504 29.044 97.4939 29.1448 96.5861C29.1448 95.7287 28.9431 94.3165 31.0109 94.3165Z",
    fill: "#EEA886"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0325 96.989C33.0325 96.989 33.4864 94.5178 31.2673 94.1143C29.0482 93.6604 28.2917 95.1734 28.0899 96.0812C27.8882 96.989 28.1404 99.5107 28.1404 99.5107C28.1404 99.5107 29.603 100.822 30.5108 101.125C30.5108 101.125 29.7543 98.4516 30.0569 96.4847C30.0569 96.4847 31.8725 96.7873 33.0325 96.4847C32.982 96.4847 33.0325 96.8882 33.0325 96.989Z",
    fill: "#16202E"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7211 100.319C31.7211 100.319 31.1663 100.319 30.3594 99.8145C30.3594 99.8145 30.9141 100.521 31.6707 100.773C31.6707 100.773 31.7211 100.42 31.7211 100.319Z",
    fill: "#A77860"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4208 113.034L22 114.083L22.7723 118.811L29.1931 117.763L28.4208 113.034Z",
    fill: "#366E9C"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M24.767 118.775C24.767 118.775 24.6661 118.624 24.6661 118.523C24.6661 118.523 24.6661 118.372 24.6661 118.221C24.6661 118.17 24.6661 118.17 24.6661 118.12C24.6661 118.019 24.5653 117.817 24.6157 117.615C24.6157 117.363 24.9183 116.405 24.9183 116.405H25.4731L26.0278 116.354C26.0278 116.354 26.6835 117.565 26.6835 117.817V117.868C26.6835 118.069 26.5826 118.17 26.5826 118.271C26.5826 118.321 26.4817 118.624 26.3809 118.674C26.2296 118.725 26.1287 118.725 26.0278 118.674C26.0278 118.674 25.7757 118.775 25.5739 118.725C25.5739 118.725 25.3218 118.826 25.12 118.725C25.1705 118.775 24.9183 118.876 24.767 118.775Z",
    fill: "#EEA886"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1927 101.527C28.1927 101.527 27.0327 101.224 26.3771 102.435C25.7214 103.695 25.7214 104.25 25.6206 104.855C25.5197 105.41 24.7632 108.89 24.7128 109.041C24.6623 109.193 24.4102 111.361 24.4102 112.118C24.4102 112.723 24.511 116.607 24.511 116.758C24.511 116.909 26.3267 116.506 26.3267 116.506C26.3267 116.506 26.1249 112.925 26.1753 112.521C26.2258 112.168 26.2762 110.252 26.478 109.697C26.6797 109.041 27.5371 105.763 27.6884 105.461C27.8397 105.158 29.151 101.93 28.1927 101.527Z",
    fill: "#EDDAD3"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M178.251 135.32L178.351 134.211C178.351 134.211 176.788 134.211 176.637 134.312C176.637 134.312 176.788 135.22 176.788 135.371C176.788 135.522 178.251 135.32 178.251 135.32Z",
    fill: "#5C544D"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M175.625 137.64C177.491 137.64 178.349 137.74 178.551 137.438C178.752 137.135 178.248 135.219 178.248 135.219C178.248 135.219 177.794 135.37 176.735 135.269C176.735 135.269 176.281 135.824 175.827 136.076C175.373 136.328 174.667 136.429 174.415 136.681C174.264 136.833 173.759 137.64 175.625 137.64Z",
    fill: "#3C4145"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M167.809 135.32L167.91 134.211C167.91 134.211 166.347 134.211 166.195 134.312C166.195 134.312 166.347 135.22 166.347 135.371C166.397 135.522 167.809 135.32 167.809 135.32Z",
    fill: "#5C544D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M165.183 137.64C167.049 137.589 167.907 137.74 168.109 137.438C168.31 137.135 167.806 135.219 167.806 135.219C167.806 135.219 167.402 135.37 166.293 135.269C166.293 135.269 165.839 135.824 165.385 136.076C164.931 136.328 163.317 136.53 163.015 136.782C162.914 136.934 162.561 137.69 165.183 137.64Z",
    fill: "#3C4145"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M176.133 110.405C176.133 110.405 176.889 112.725 176.788 114.692C176.688 116.659 177.192 118.828 177.394 120.896C177.646 123.216 178.554 128.662 178.604 129.923C178.655 131.134 178.453 135.118 178.453 135.118L176.587 135.168C176.587 135.168 175.023 125.636 174.62 124.628C174.216 123.669 172.199 116.71 172.098 115.903C172.048 115.096 176.133 110.405 176.133 110.405Z",
    fill: "#DBD8E3"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M168.211 110.81C168.211 110.81 167.202 116.257 167.051 117.467C166.9 118.677 166.849 123.317 166.748 124.074C166.698 124.83 166.294 134.009 165.941 135.119H168.362C168.362 135.119 170.178 128.462 170.178 125.284C170.178 122.107 171.59 118.425 172.498 116.357C173.406 114.29 175.524 114.239 176.079 110.356C176.129 110.406 169.018 109.599 168.211 110.81Z",
    fill: "#DBD8E3"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M173.1 92.2495C173.1 92.2495 171.234 91.5434 170.326 93.006C169.469 94.4686 169.519 97.3433 170.477 97.6964C171.436 98.0494 172.848 97.8477 173.352 96.9903C173.856 96.0825 174.26 94.7712 174.26 93.9138C174.26 92.9556 173.604 92.5017 173.1 92.2495Z",
    fill: "#EEA886"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M170.835 97.5451C170.835 97.5451 170.936 98.0494 170.784 98.3016C170.683 98.5538 173.155 98.5538 173.155 98.5538C173.155 98.5538 173.356 97.2425 173.76 96.0825C174.113 94.973 170.835 97.5451 170.835 97.5451Z",
    fill: "#EEA886"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M173.764 96.0837C173.764 96.0837 173.613 96.3863 172.907 96.235C172.2 96.1341 171.343 95.1758 171.04 95.075C170.738 94.9741 170.738 94.8228 170.738 94.8228L170.536 95.075H170.234C170.234 95.075 170.536 94.2176 170.082 93.915C169.628 93.5619 170.536 91.1915 172.806 91.9985C172.806 91.9985 174.42 92.3011 174.52 93.3098C174.621 94.3689 174.117 95.5793 173.764 96.0837Z",
    fill: "#FCCCA2"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M170.629 98.2519C170.629 98.2519 170.629 97.798 170.831 97.7475C171.032 97.6971 173.151 97.4953 173.403 97.5962V98.151C173.453 98.151 172.949 98.4536 170.629 98.2519Z",
    fill: "#E2D2CA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M170.738 94.4689C170.788 94.3176 171.192 93.8132 171.343 94.3176C171.494 94.8219 171.091 95.528 170.889 95.4271C170.688 95.4271 170.637 94.9228 170.738 94.4689Z",
    fill: "#EEA886"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M170.63 98.2529C170.63 98.2529 169.47 98.6563 168.108 99.2615C168.108 99.2615 166.545 99.8163 166.394 101.531C166.293 102.439 165.335 107.281 165.133 107.684C164.931 108.088 162.813 114.644 162.712 114.795C162.662 114.947 164.477 115.703 164.578 115.653C164.679 115.602 166.646 109.651 166.848 109.248C166.848 109.248 167.957 105.717 168.008 105.162C168.008 105.162 168.058 106.675 168.108 107.079C168.159 107.482 167.1 115.703 167.15 115.955C167.201 116.207 171.992 116.46 173.908 116.258C175.825 116.056 177.388 115.602 177.388 115.602C177.388 115.602 175.875 109.096 175.926 108.39C176.027 106.827 176.531 103.851 176.531 103.851L178.094 106.776L176.077 111.921L176.531 113.484C176.531 113.484 180.263 107.835 180.364 107.331C180.465 106.827 180.162 106.171 179.96 105.717C179.759 105.314 178.498 102.086 178.195 101.632C177.893 101.178 177.388 99.3624 176.127 98.8581C175.119 98.4546 173.354 98.1016 173.354 98.1016L170.63 98.2529Z",
    fill: "#63A4FF"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M169.616 111.631L160.871 109.389L159.305 115.496L168.05 117.738L169.616 111.631Z",
    fill: "#F25F54"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M162.002 116.105C162.002 116.105 161.75 116.509 161.649 116.61C161.548 116.711 161.851 116.812 162.002 116.66C162.153 116.61 162.002 116.105 162.002 116.105Z",
    fill: "#C98462"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M163.823 117.518C163.823 117.518 163.974 117.366 164.025 117.266C164.025 117.266 164.075 117.064 164.125 116.963C164.125 116.912 164.125 116.862 164.176 116.862C164.226 116.761 164.327 116.559 164.378 116.307C164.428 116.055 164.529 114.946 164.529 114.946L163.873 114.794L163.318 114.693C163.318 114.693 162.158 115.853 162.058 116.106V116.156C162.007 116.358 162.058 116.509 162.058 116.61C162.058 116.66 162.058 117.064 162.158 117.114C162.259 117.215 162.411 117.215 162.511 117.215C162.511 117.215 162.764 117.417 162.965 117.366C162.965 117.366 163.218 117.568 163.47 117.467C163.419 117.417 163.671 117.619 163.823 117.518Z",
    fill: "#DE9D7D"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M166.502 110.405C166.502 110.405 164.938 115.095 164.636 115.6C164.636 115.6 163.476 115.347 162.77 114.742L164.484 109.648L166.502 110.405Z",
    fill: "#63A4FF"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M306.859 117.77C306.859 117.77 312.659 100.825 301.614 95.5795C290.569 90.3343 281.238 97.8994 279.473 102.035C277.708 106.12 278.162 113.635 279.675 118.83C281.188 124.024 280.986 131.993 277.708 134.615C274.43 137.288 270.345 141.676 270.546 150.654C270.647 156.201 292.435 136.431 292.435 136.431L306.859 117.77Z",
    fill: "#252E3B"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M291.376 137.894C291.376 137.894 282.298 139.911 278.717 142.029C275.136 144.148 267.117 153.78 267.117 157.966C267.117 162.102 302.068 165.985 302.068 165.985L308.675 190.143C308.675 190.143 326.327 185.857 328.445 182.276C330.563 178.695 321.737 153.074 320.224 147.93C318.711 142.634 312.357 138.953 304.993 137.944C297.68 136.885 291.376 137.894 291.376 137.894Z",
    fill: "#FFD255"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M304.384 137.842C304.384 137.842 304.182 148.837 295.457 149.19C286.732 149.493 288.547 138.649 288.547 138.649C288.547 138.649 294.902 136.027 304.384 137.842Z",
    fill: "#EEA886"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M308.068 104.606C308.068 104.606 311.144 122.309 302.368 135.119C293.24 148.333 308.068 104.606 308.068 104.606Z",
    fill: "#252E3B"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M302.524 130.025C302.524 130.025 301.919 135.27 302.928 138.548C303.936 141.826 289.562 141.927 289.562 139.204C289.562 136.127 291.025 133.605 289.663 128.36C288.302 123.166 302.524 130.025 302.524 130.025Z",
    fill: "#EEA886"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M291.379 130.731C291.379 130.731 295.918 135.472 301.718 131.236C301.718 131.236 301.214 134.262 297.078 134.665C292.892 135.018 291.379 130.731 291.379 130.731Z",
    fill: "#A77860"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M297.069 98.4536C297.069 98.4536 308.517 101.833 306.903 117.77C305.289 133.657 297.775 132.85 297.069 133.001C296.363 133.102 287.486 133.707 284.662 114.391C281.837 95.0745 297.069 98.4536 297.069 98.4536Z",
    fill: "#EEA886"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M294.098 105.564C294.098 105.564 300.352 115.5 306.909 117.769C306.909 117.769 310.489 101.126 295.712 97.6461C280.935 94.1662 283.255 114.441 284.364 119.837C284.314 119.837 287.391 111.869 294.098 105.564Z",
    fill: "#252E3B"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M285.727 104.052C285.727 104.052 289.005 97.6971 294.553 97.3945C300.1 97.0919 303.378 101.934 303.378 101.934C303.378 101.934 301.21 96.5371 294.553 96.5371C287.895 96.5371 285.727 104.052 285.727 104.052Z",
    fill: "#88C0FF"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M308.265 153.98L312.148 190.142H261.008L257.074 153.98H308.265Z",
    fill: "#5FA0FF"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M310.942 188.932H259.297L255.363 152.316H307.008L310.942 188.932ZM259.701 188.478H310.437L306.604 152.77H255.868L259.701 188.478Z",
    fill: "#5FA0FF"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M287.788 171.48C288.242 173.75 287.183 175.868 285.468 176.221C283.703 176.574 281.938 175.061 281.484 172.792C281.03 170.522 282.089 168.404 283.804 168.051C285.569 167.698 287.334 169.261 287.788 171.48Z",
    fill: "#5189DB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M307.362 190.164H316.895V186.533H307.362V190.164Z",
    fill: "#5FA0FF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M328.083 81.6065C323.745 81.6065 320.215 78.0761 320.215 73.7388C320.215 69.4015 323.745 65.8711 328.083 65.8711C332.42 65.8711 335.95 69.4015 335.95 73.7388C335.95 78.0761 332.42 81.6065 328.083 81.6065ZM328.083 66.325C323.997 66.325 320.669 69.6536 320.669 73.7388C320.669 77.824 323.997 81.1526 328.083 81.1526C332.168 81.1526 335.496 77.824 335.496 73.7388C335.496 69.6536 332.168 66.325 328.083 66.325Z",
    fill: "#64A4FF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M138.759 161.646V160.99C140.071 160.99 141.432 160.939 142.744 160.889L142.794 161.545C141.483 161.595 140.121 161.646 138.759 161.646ZM134.775 161.595C133.464 161.545 132.102 161.494 130.74 161.393L130.791 160.738C132.153 160.839 133.464 160.889 134.775 160.939V161.595ZM146.829 161.293L146.778 160.637C148.09 160.536 149.451 160.385 150.763 160.233L150.864 160.889C149.502 161.04 148.14 161.141 146.829 161.293ZM126.706 161.091C125.344 160.939 123.982 160.788 122.721 160.586L122.822 159.931C124.083 160.133 125.445 160.334 126.756 160.435L126.706 161.091ZM154.797 160.284L154.697 159.628C156.008 159.426 157.319 159.174 158.63 158.872L158.782 159.527C157.42 159.78 156.109 160.032 154.797 160.284ZM118.737 159.78C117.375 159.477 116.064 159.073 114.854 158.67L115.055 158.014C116.266 158.418 117.527 158.821 118.888 159.124L118.737 159.78ZM162.716 158.62L162.564 157.964C163.775 157.661 165.086 157.359 166.448 156.955L166.599 157.611C165.187 158.014 163.926 158.367 162.716 158.62ZM111.122 157.157C109.861 156.552 108.701 155.896 107.591 155.19L107.944 154.635C109.003 155.341 110.163 155.997 111.374 156.602L111.122 157.157ZM170.482 156.602L170.281 155.947C170.836 155.795 171.39 155.644 171.945 155.493C172.702 155.291 173.408 155.089 174.164 154.887L174.366 155.543C173.66 155.745 172.903 155.947 172.147 156.148C171.592 156.249 171.037 156.451 170.482 156.602ZM205.383 156.047C204.172 155.442 202.912 154.938 201.701 154.534L201.903 153.929C203.113 154.383 204.374 154.887 205.635 155.493L205.383 156.047ZM178.199 154.434L178.048 153.778C179.51 153.425 180.771 153.122 181.981 152.87L182.133 153.526C180.922 153.778 179.661 154.08 178.199 154.434ZM197.868 153.374C196.557 153.072 195.246 152.87 193.934 152.719L193.985 152.063C195.296 152.214 196.658 152.416 197.969 152.719L197.868 153.374ZM186.016 152.87L185.915 152.214C187.327 152.013 188.639 151.912 189.95 151.912V152.567C188.689 152.618 187.428 152.719 186.016 152.87ZM104.414 152.668C103.405 151.76 102.497 150.701 101.69 149.642L102.245 149.239C103.002 150.298 103.909 151.256 104.868 152.164L104.414 152.668ZM99.5721 146.162C98.9669 144.952 98.513 143.691 98.1096 142.38L98.7652 142.178C99.1182 143.489 99.6226 144.7 100.177 145.86L99.5721 146.162ZM97.2522 138.395C97.1009 137.084 97 135.722 97 134.361H97.6556C97.6556 135.722 97.7565 137.034 97.9078 138.345L97.2522 138.395ZM97.8574 130.376L97.2017 130.326C97.353 129.015 97.5548 127.653 97.8069 126.342L98.4626 126.493C98.2104 127.754 98.0087 129.065 97.8574 130.376ZM99.3704 122.559L98.7148 122.357C99.3704 119.987 100.026 118.575 100.026 118.524L100.682 118.777C100.682 118.777 100.076 120.239 99.3704 122.559Z",
    fill: "#C2BEBC"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M293.852 41.3109C293.852 41.3109 292.742 40.3022 290.725 38.8396L291.128 38.2848C293.146 39.7979 294.306 40.8066 294.306 40.8066L293.852 41.3109ZM287.447 36.5197C286.337 35.7631 285.227 35.0571 284.068 34.351L284.421 33.7962C285.581 34.5023 286.741 35.2084 287.85 35.9649L287.447 36.5197ZM280.588 32.3841C279.428 31.7284 278.217 31.1232 277.007 30.5684L277.309 29.9632C278.52 30.518 279.73 31.1736 280.89 31.7789L280.588 32.3841ZM273.375 28.9545C272.115 28.4502 270.904 27.9459 269.643 27.492L269.845 26.8867C271.106 27.3407 272.367 27.845 273.628 28.3493L273.375 28.9545ZM222.538 28.0972V27.4415C223.849 27.3911 225.16 27.2902 226.472 27.0885L226.573 27.7441C225.211 27.9459 223.849 28.0972 222.538 28.0972ZM218.453 27.8954C217.141 27.7441 215.83 27.4919 214.468 27.0885L214.62 26.4328C215.931 26.7859 217.242 27.038 218.503 27.1893L218.453 27.8954ZM230.506 26.8363L230.305 26.1807C230.759 26.0294 231.162 25.9285 231.616 25.7772C232.473 25.4746 233.331 25.2224 234.138 24.9702L234.339 25.6259C233.482 25.8781 232.675 26.1302 231.818 26.3824C231.414 26.5337 230.96 26.685 230.506 26.8363ZM265.861 26.2311C264.6 25.8276 263.289 25.525 261.977 25.2224L262.129 24.5668C263.44 24.8694 264.751 25.2224 266.012 25.5755L265.861 26.2311ZM210.635 25.8276C209.475 25.3737 208.265 24.8189 206.954 24.2137L207.256 23.6085C208.568 24.2137 209.728 24.7685 210.888 25.2224L210.635 25.8276ZM238.223 24.7181L238.072 24.0624C239.383 23.8103 240.745 23.5581 242.056 23.4068L242.157 24.0624C240.845 24.2137 239.534 24.4155 238.223 24.7181ZM258.044 24.4659C256.732 24.2642 255.37 24.0624 254.11 23.9616L254.16 23.3059C255.471 23.4572 256.833 23.6085 258.144 23.8103L258.044 24.4659ZM140.431 23.8103L140.078 23.2555C141.238 22.499 142.398 21.7929 143.508 21.1373L143.861 21.692C142.701 22.3477 141.591 23.0537 140.431 23.8103ZM246.141 23.7094L246.091 23.0537C247.402 23.0033 248.764 22.9529 250.125 23.0033V23.659C248.764 23.659 247.452 23.659 246.141 23.7094ZM203.373 22.3981C202.263 21.7929 201.103 21.1373 199.843 20.4312L200.196 19.826C201.456 20.532 202.566 21.1373 203.676 21.7929L203.373 22.3981ZM147.29 19.6747L146.988 19.0695C148.198 18.4138 149.408 17.7582 150.568 17.2034L150.871 17.8086C149.661 18.4138 148.501 19.019 147.29 19.6747ZM196.363 18.4642C195.051 17.7582 193.891 17.153 192.832 16.5982L193.135 15.993C194.194 16.5477 195.404 17.153 196.716 17.859L196.363 18.4642ZM154.452 16.1443L154.2 15.5391C155.461 14.9843 156.721 14.48 157.932 14.026L158.184 14.6313C156.974 15.0852 155.713 15.5895 154.452 16.1443ZM189.201 14.9339C187.94 14.3791 186.679 13.9252 185.469 13.5217L185.671 12.8661C186.931 13.2695 188.142 13.7234 189.453 14.2782L189.201 14.9339ZM161.967 13.4208L161.765 12.7652C163.076 12.3617 164.387 12.0591 165.699 11.8069L165.85 12.4626C164.539 12.7148 163.278 13.0174 161.967 13.4208ZM181.636 12.4626C180.325 12.16 179.013 11.9582 177.702 11.8069L177.752 11.1513C179.064 11.3026 180.425 11.5043 181.737 11.8069L181.636 12.4626ZM169.784 11.8574L169.733 11.2017C171.095 11.0504 172.457 11 173.768 11V11.6556C172.457 11.6556 171.095 11.7061 169.784 11.8574Z",
    fill: "#C2BEBC"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M228.689 163.362L211.844 158.47L216.887 156.957L228.689 163.362Z",
    fill: "#D6D6D6"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M228.684 163.36L222.38 157.056L218.496 157.863L228.684 163.36Z",
    fill: "#E8E8E8"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M215.719 159.631L215.82 161.547L228.68 163.363L215.719 159.631Z",
    fill: "#C2C2C2"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M144.016 34.9553L158.843 26.6337L153.699 26.3311L144.016 34.9553Z",
    fill: "#D6D6D6"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M144.016 34.9555L148.555 27.5921L152.388 27.4912L144.016 34.9555Z",
    fill: "#E8E8E8"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M155.414 28.5508L155.716 30.4168L144.016 34.9559L155.414 28.5508Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1046_17454",
    x: 0,
    y: 0,
    width: 442,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1046_17454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1046_17454",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1046_17454",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.012 156.781) rotate(3.2764) scale(172.08 171.884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1602,
    stopColor: "#90C2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    stopColor: "#47AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6783F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1046_17454",
    x1: -15.9994,
    y1: 90.0363,
    x2: 456.737,
    y2: 164.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1046_17454",
    x1: 342.591,
    y1: 124.558,
    x2: 420.457,
    y2: 124.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5599FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1046_17454",
    x1: 48.0526,
    y1: 76.7092,
    x2: 105.893,
    y2: 70.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5599FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_17454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434,
    height: 189,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogThumbnail2);
export default __webpack_public_path__ + "static/media/blogThumbnail2.7cb3d88b853a74968d21956242faeef5.svg";
export { ForwardRef as ReactComponent };